
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.95 8.464a1 1 0 10-1.414-1.414L12 10.586 8.464 7.05A1 1 0 107.05 8.464L10.586 12 7.05 15.536a1 1 0 001.414 1.414L12 13.414l3.536 3.536a1 1 0 001.414-1.414L13.414 12l3.536-3.536z","fill":"#999392"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"10","stroke":"#999392","stroke-width":"2"}})])
          )
        }
      }
    